<template>
  <StandardEmptyPageContainer>
    <v-card class="pa-8 fill-height" flat style="border-radius: 12px">
      <v-row justify="center">
        <v-col cols="8" align="center">
          <QuestionnaireHeader :tlc="tlc" />
          <v-combobox
            v-if="
              selectedQuestionnaireStore.questionnaire.templateId !==
              'PwC Pilot Template'
            "
            v-model="language"
            :items="Languages"
            label="Select language"
            variant="outlined"
            density="compact"
            item-title="text"
            item-value="id"
            style="width: 12rem"
          />
          <PActionButton
            :append-icon="true"
            :icon-size="'xs'"
            :loading="isLoading"
            appkit-icon="icon-right-chevron-fill"
            @click="startQuestionnaire"
            >Start
          </PActionButton>
        </v-col>
      </v-row>
    </v-card>
  </StandardEmptyPageContainer>
</template>

<script setup lang="ts">
import StandardEmptyPageContainer from "@/components/containers/StandardEmptyPageContainer.vue";
import QuestionnaireHeader from "@/components/questionnaire/QuestionnaireHeader.vue";
import PActionButton from "@/components/custom/buttons/PActionButton.vue";
import { Languages } from "@/models/const/languages";
import type { QuestionnaireItemSetDto } from "@/models/dto/questionnaireItemSetDto";
import { useSelectedQuestionnaire } from "@/stores/selectedQuestionnare";
import { computed, ref, type Ref } from "vue";
import { RouterPath } from "@/models/enum/routerPath";
import { useRouter } from "vue-router";

const selectedQuestionnaireStore = useSelectedQuestionnaire();
const router = useRouter();

const language = ref(Languages[0]);
const isLoading = ref(false);

const tlc = computed(
  () => selectedQuestionnaireStore.questionnaire?.tlcName ?? ""
);

const itemSets: Ref<QuestionnaireItemSetDto[]> = ref([]);
const contextId = computed(
  () => selectedQuestionnaireStore.questionnaire?.contextId ?? ""
);

async function startQuestionnaire(): Promise<void> {
  isLoading.value = true;
  itemSets.value = await selectedQuestionnaireStore.getSelectedQuestionnaire(
    contextId.value,
    language.value.id
  );
  router.push(RouterPath.Questionnaire);
  isLoading.value = false;
}
</script>
